import { Injectable } from "@angular/core";
import { HomeHeaderLoginExtension } from "@geolib/geoappbase-client";
import LoginController from "../login/LoginController";


@Injectable({ providedIn: "root" })
export class GeobusStartPageExtension extends HomeHeaderLoginExtension<LoginController> {

    public constructor() {
        super();
    }

    public isEnabled(): boolean {
        return true;
    }

    public get component(): typeof LoginController {
        return LoginController;
    }
}
